import { getRequest } from "@/utils";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface NotificationStore {
  isLoading: boolean;
  error: string | null;
  unreads: number;
  messages: {
    from: string;
    id: string;
    lead_id: number;
    subject: string;
    to: string;
    lead_name: string;
  }[];
  fetchUnreads: () => Promise<void>;
  clearUnreads: () => void;
}

export const useNotificactionStore = create<NotificationStore>()(
  devtools((set) => ({
    unreads: 0,
    messages: [],
    isLoading: false,
    error: null,
    fetchUnreads: async () => {
      const data = (await getRequest(
        "mail/has-unreads",
        "default",
      )) as unknown as {
        message: { count: number; messages: NotificationStore["messages"] };
      };

      set({ unreads: data.message.count, messages: data.message.messages });
    },
    clearUnreads: () => set({ unreads: 0, messages: [] }),
  })),
);
